export default {"src":"/_next/static/image/public/images/social_snapchat_white.67c595a62ada6d7603b97c52df5a55d1.svg","height":17,"width":19};